import { Publication } from '../types/publication';

export const publications: Publication[] = [
  {
    id: 'hamamura2026dynamic',
    type: 'article',
    title: 'Efficient implementation of randomized quantum algorithms with dynamic circuits',
    authors: ['S. Kanno', 'I. Hamamura', 'R. Raymond', 'Q. Gao', 'N. Yamamoto'],
    journal: 'IEEE Trans. Quantum Eng.',
    volume: '7',
    pages: '1',
    year: 2026,
    doi: '10.1109/TQE.2026.3671723',
    url: 'https://doi.org/10.1109/TQE.2026.3671723',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2026generative',
    type: 'misc',
    title: 'Generative Circuit Design for Quantum-Selected Configuration Interaction',
    authors: ['R. Kemmoku', 'Q. Gao', 'S. Kanno', 'K. Keithley', 'I. Hamamura', 'N. Yamamoto', 'K. Nakaji'],
    journal: 'arXiv:2604.09756',
    year: 2026,
    url: 'https://arxiv.org/abs/2604.09756',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2026auger',
    type: 'misc',
    title: 'Auger Spectroscopy via Generative Quantum Eigensolver: A Quantum Approach to Molecular Excitations',
    authors: [
      'Kimberlee Keithley', 'Shunsuke Yamamoto', 'Ryota Kenmoku', 'Ikko Hamamura', 'Kouhei Nakaji',
      'Shu Kanno', 'Takao Kobayashi', 'Qi Gao', 'Shumpei Uno', 'Kohei Oshio',
      'Naoki Watanabe', 'Takeshi Sato', 'Naoki Yamamoto', 'Shunya Minami', 'Yohichi Suzuki',
      'Yuma Nakamura', 'Jorge A. Campos-Gonzalez-Angulo', 'Mohammad Ghazi Vakili', 'Alán Aspuru-Guzik',
    ],
    journal: 'arXiv:2603.12859',
    year: 2026,
    url: 'https://arxiv.org/abs/2603.12859',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2026mcp',
    type: 'inproceedings',
    title: 'A Model Context Protocol Server for Quantum Execution in Hybrid Quantum-HPC Environments',
    authors: ['Masaki Shiraishi', 'Ikko Hamamura', 'Tatsuya Ishigaki', 'Tadashi Kadowaki'],
    booktitle: 'QC4C3 workshop at QCNC 2026',
    journal: 'arXiv:2604.08318',
    year: 2026,
    url: 'https://arxiv.org/abs/2604.08318',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025diagonalization',
    type: 'article',
    title: 'Diagonalization of large many-body Hamiltonians on a quantum processor',
    authors: [
      'N. Yoshioka', 'M. Amico', 'W. Kirby', 'P. Jurcevic', 'A. Dutt',
      'B. Fuller', 'S. Garion', 'H. Haas', 'I. Hamamura', 'A. Ivrii',
      'R. Majumdar', 'Z. Minev', 'M. Motta', 'B. Pokharel', 'P. Rivero',
      'K. Sharma', 'C. J. Wood', 'A. Javadi-Abhari', 'A. Mezzacapo',
    ],
    journal: 'Nature Communications',
    volume: '16',
    pages: '5014',
    year: 2025,
    doi: '10.1038/s41467-025-59716-z',
    url: 'https://doi.org/10.1038/s41467-025-59716-z',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025ai',
    type: 'article',
    title: 'Artificial Intelligence for Quantum Computing',
    authors: [
      'Yuri Alexeev', 'Marwa H. Farag', 'Taylor L. Patti', 'Mark E. Wolf', 'Natalia Ares',
      'Alán Aspuru-Guzik', 'Simon C. Benjamin', 'Zhenyu Cai', 'Shuxiang Cao', 'Christopher Chamberland',
      'Zohim Chandani', 'Federico Fedele', 'Ikko Hamamura', 'Nicholas Harrigan', 'Jin-Sung Kim',
      'Elica Kyoseva', 'Justin G. Lietz', 'Tom Lubowe', 'Alexander McCaskey', 'Roger G. Melko',
      'Kouhei Nakaji', 'Alberto Peruzzo', 'Pooja Rao', 'Bruno Schmitt', 'Sam Stanwyck',
      'Norm M. Tubman', 'Hanrui Wang', 'Timothy Costa',
    ],
    journal: 'Nature Communications',
    year: 2025,
    doi: '10.1038/s41467-025-65836-3',
    url: 'https://doi.org/10.1038/s41467-025-65836-3',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025diffusion',
    type: 'article',
    title: 'Synthesis of discrete-continuous quantum circuits with multimodal diffusion models',
    authors: ['F. Fürrutter', 'Z. Chandani', 'I. Hamamura', 'H. J. Briegel', 'G. Muñoz-Gil'],
    journal: 'Mach. Learn.: Sci. Technol.',
    year: 2025,
    url: 'https://arxiv.org/abs/2506.01666',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025bench',
    type: 'misc',
    title: 'QuantumBench: A Benchmark for Quantum Problem Solving',
    authors: [
      'S. Minami', 'T. Ishigaki', 'I. Hamamura', 'T. Mikuriya', 'Y. Ma',
      'N. Okazaki', 'H. Takamura', 'Y. Suzuki', 'T. Kadowaki',
    ],
    journal: 'arXiv:2511.00092',
    year: 2025,
    url: 'https://arxiv.org/abs/2511.00092',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025ergodic',
    type: 'article',
    title: 'Observation of constructive interference at the edge of quantum ergodicity',
    authors: ['D. A. Abanin', 'R. Acharya', 'X. Mi', 'K. Kechedzhi', 'N. Zobrist', 'et al.'],
    journal: 'Nature',
    volume: '646',
    pages: '825-830',
    year: 2025,
    doi: '10.1038/s41586-025-09526-6',
    url: 'https://doi.org/10.1038/s41586-025-09526-6',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025sano',
    type: 'article',
    title: 'Quantum State Preparation for Probability Distributions with Reflection Symmetry Using Matrix Product States',
    authors: ['Y. Sano', 'I. Hamamura'],
    journal: 'Phys. Rev. Applied',
    volume: '24',
    pages: '034062',
    year: 2025,
    doi: '10.1103/PhysRevApplied.24.034062',
    url: 'https://doi.org/10.1103/PhysRevApplied.24.034062',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2024hamiltonian',
    type: 'article',
    title: 'Hamiltonian simulation for hyperbolic partial differential equations by scalable quantum circuits',
    authors: ['Y. Sato', 'R. Kondo', 'I. Hamamura', 'T. Onodera', 'N. Yamamoto'],
    journal: 'Phys. Rev. Research',
    volume: '6',
    pages: '033246',
    year: 2024,
    doi: '10.1103/PhysRevResearch.6.033246',
    url: 'https://doi.org/10.1103/PhysRevResearch.6.033246',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2023vqe',
    type: 'article',
    title: 'Enhancing VQE Convergence for Optimization Problems with Problem-specific Parameterized Quantum Circuits',
    authors: ['A. Matsuo', 'Y. Suzuki', 'I. Hamamura', 'S. Yamashita'],
    journal: 'IEICE TRANSACTIONS on Information and Systems',
    volume: 'E106-D',
    number: '11',
    pages: '1772-1782',
    year: 2023,
    doi: '10.1587/transinf.2023EDP7071',
    url: 'https://doi.org/10.1587/transinf.2023EDP7071',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2020entangled',
    type: 'article',
    title: 'Efficient evaluation of quantum observables using entangled measurements',
    authors: ['I. Hamamura', 'T. Imamichi'],
    journal: 'npj Quantum Information',
    volume: '6',
    pages: '56',
    year: 2020,
    doi: '10.1038/s41534-020-0284-2',
    url: 'https://doi.org/10.1038/s41534-020-0284-2',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2019relation',
    type: 'article',
    title: 'Relation between state-distinction power and disturbance in quantum measurements',
    authors: ['I. Hamamura', 'T. Miyadera'],
    journal: 'J. Math. Phys.',
    volume: '60',
    number: '082103',
    year: 2019,
    url: 'https://doi.org/10.1063/1.5109446',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2018separability',
    type: 'article',
    title: 'Separability Criterion for Quantum Effects',
    authors: ['I. Hamamura'],
    journal: 'Phys. Lett. A',
    volume: '382',
    number: '36',
    year: 2018,
    url: 'https://doi.org/10.1016/j.physleta.2018.06.043',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2017structure',
    type: 'article',
    title: '量子論における合成系の構造',
    authors: ['濵村 一航'],
    journal: '物性研究・電子版',
    publisher: '物性研究刊行会',
    volume: '6',
    number: '2',
    pages: '062601',
    year: 2017,
    doi: '10.14989/225170',
    url: 'https://dx.doi.org/10.14989/225170',
    category: 'thesis',
  },
  {
    id: 'hamamura2017incompatibility',
    type: 'article',
    title: '操作の両立不可能性と情報擾乱の関係',
    authors: ['濵村一航'],
    journal: '数理解析研究所講究録',
    publisher: '京都大学数理解析研究所',
    volume: '2059',
    pages: '113-129',
    year: 2017,
    category: 'kiyo',
  },
];
